var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-event"},[_c('join-event-template',{attrs:{"awardsSetImg":_vm.awardsSetImg,"applyImg":_vm.applyImg,"id":_vm.id,"swiperImg":_vm.swiperImg,"eventDetail":_vm.eventDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }